import React, {useState} from 'react';
import {connect} from 'react-redux';
import Navbar from "../../components/Navbar";
import MenuPanel from "../../components/MenuPanel";

const Layout = ({children}) => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <React.Fragment>
            <Navbar onToggleMenu={() => setMenuOpen(open => !open)} />
            {children}
            <MenuPanel open={menuOpen} onClose={() => setMenuOpen(false)} />
        </React.Fragment>
    );
}
export default connect()(Layout);